import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { NightModeControlStyle } from '../styles/nightMode.style';

const NightModeControl = ({ onThemeToggle }) => {
    const { icon } = useContext(ThemeContext);
    return (
        <NightModeControlStyle className="outside-shadow">
            <div 
                className="day-night outside-shadow hover-in-shadow"
                onClick={onThemeToggle}
            >
                {icon}
            </div>
            <h4>Hi, Welcome Here</h4>
            <div className="horizontal-line"></div>
        </NightModeControlStyle>
    )
}

export default NightModeControl
